
<search-dropdown 
  [items]="manufacturers" 
  [label]="'name'" 
  [uid]="'id'" 
  [placeholder]="_placeholder"
  (afterChange)="onChanged($event)"
  [(ngModel)]="manufacturerId">
</search-dropdown>